import { Box, Stack, styled, Typography } from '@mui/material';

export const StyledMainBox = styled(Box)(() => ({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}));

export const StyledImageBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100px',
  height: '100px',
  borderRadius: '4px',
  overflow: 'hidden',
  border: '1px solid',
  borderColor: theme.palette.divider,
  position: 'relative',
}));

export const StyledBackupBox = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: '8px',
}));

export const StyledBackupItemStack = styled(Stack)(({ theme, $isLast }) => ({
  padding: '12px',
  borderBottom: $isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyledBackupItemContentBox = styled(Box)(() => ({
  overflow: 'hidden',
  marginRight: '8px',

  '& .MuiLink-root': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    overflow: 'hidden',
  },
}));

export const StyledHeaderStack = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '16px',
  alignItems: 'center',
}));

export const StyledMetadataStack = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '8px',
  flexWrap: 'wrap',
}));

export const StyledDateRangeStack = styled(Stack)(() => ({
  flexDirection: 'row',
  flex: 1,
  gap: '16px',
}));

export const StyledDateLabelTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  color: theme.palette.text.primary,
}));

export const StyledDateInnerStack = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
}));
